import { Menu } from 'lucide-react';
import type { Ref } from 'react';
import { IconButton, cn } from '@helios/ui';
import { ConstructionOsLogo } from '@/components/brand/ConstructionOsLogo';
import { FilterBar } from '@/components/layout/FilterBar';
import { HeaderSearch } from '@/components/layout/HeaderSearch';
import { NotificationsMenu } from '@/components/layout/NotificationsMenu';
import { UserMenu } from '@/components/layout/UserMenu';
import { useUiStore } from '@/stores/uiStore';

export function TopBar({
  advisorLauncherRef,
}: {
  advisorLauncherRef?: Ref<HTMLButtonElement>;
} = {}) {
  const setMobileNavOpen = useUiStore((state) => state.setMobileNavOpen);
  const advisorOpen = useUiStore((state) => state.advisorOpen);
  const toggleAdvisor = useUiStore((state) => state.toggleAdvisor);

  return (
    <header className="z-header bg-background/55 backdrop-blur-glass-strong relative flex h-14 shrink-0 items-center gap-2 border-b border-white/[0.08] px-3 shadow-[0_1px_0_0_hsl(0_0%_100%/0.06),0_16px_40px_-28px_hsl(0_0%_0%)] sm:px-4">
      {/* Mobile: open nav drawer + brand */}
      <IconButton
        label="Open navigation"
        className="rounded-full lg:hidden"
        onClick={() => setMobileNavOpen(true)}
      >
        <Menu className="h-5 w-5" aria-hidden="true" />
      </IconButton>
      <ConstructionOsLogo variant="toolbar" className="lg:hidden" />

      <HeaderSearch />

      <div className="hidden md:block">
        <FilterBar />
      </div>

      <div className="ml-auto flex shrink-0 items-center gap-1.5">
        <NotificationsMenu />
        <IconButton
          ref={advisorLauncherRef}
          label="Toggle Helios AI"
          aria-pressed={advisorOpen}
          onClick={toggleAdvisor}
          size="lg"
          className={cn('rounded-full', advisorOpen && 'bg-primary/15 text-primary shadow-glow')}
        >
          <ConstructionOsLogo variant="toolbar" />
        </IconButton>
        <UserMenu />
      </div>
    </header>
  );
}
